export const REDUX = "redux";
export const LANG = "lang";
export const SHOW = "show";
export const SHOW_MAJOR = "showMajor";
